import {
  forwardRef,
  ReactNode,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';
import classNames from 'classnames';
import { Subject } from 'rxjs/internal/Subject';
import swiperCss from '@edikk-edikk/country-frontend/css/modules/swiper.module.scss';
import { useStoryListContext } from '#advertStory/list';
import { StoryDetailListDataType, StoryDetailListType, useInit } from '#advertStory/detail-list';
import { StoryDetail } from '#advertStory/detail';
import storyDetailListCss from '../assets/detail/story-detail-list.module.scss';

type PropsType = {
  additionalClassName?: string;
  initialSlide: number;
};

const StoryDetailList = forwardRef<StoryDetailListType, PropsType>((
  {
    additionalClassName,
    initialSlide,
  },
  forwardedRef,
) => {
  const { storyDataList } = useStoryListContext();
  const refSwiper = useRef<HTMLDivElement>(null);
  const { currentSlide, progress } = useInit(refSwiper, initialSlide);
  const dataSubject = useMemo(() => new Subject<StoryDetailListDataType>(), []);

  useEffect(() => {
    dataSubject.next({
      currentSlide,
      progress,
    });
  }, [currentSlide, dataSubject, progress]);

  useImperativeHandle<StoryDetailListType, StoryDetailListType>(forwardedRef, () => ({
    dataSubject,
  }), [dataSubject]);

  const storyDetailElementList = storyDataList.map((story): ReactNode => (
    <div key={story.id} className={swiperCss.swiper__slide}>
      <StoryDetail story={story} />
    </div>
  ));

  return (
    <div
      className={classNames(
        swiperCss.swiper,
        storyDetailListCss.storyDetailList,
        additionalClassName,
      )}
      ref={refSwiper}
    >
      <div className={swiperCss.swiper__wrapper}>
        {storyDetailElementList}
      </div>
    </div>
  );
});

export { StoryDetailList };
